// eslint-disable-next-line no-unused-vars
import React, { forwardRef } from 'react';
import { node, bool, func } from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import ToastNotificationsComponent from 'Components/ToastNotifications/ToastNotifications';
import BalanceDueModal from 'Containers/Header/BalanceDueModal';
import StockAlertModal from 'Containers/Header/StockAlertModal';
import AddToWishlistModal from 'Containers/Wishlists/AddToWishlistModal';
import ExternalSupplierModal from 'Containers/Product/ExternalSupplierModal';
import useUser from 'Hooks/useUser';

const StyledHeader = styled.div`
  top: -2px;
  position: relative;
  width: 100%;
  height: ${props => props.canFloat ? '80px' : '112px'};
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #040F2A 0%, #041B54 100%);
  transition: max-height 0.15s ease;

  @media screen and (max-width: 767px) {
    height: ${props => props.canFloat ? '111px' : '111px'};
  }
`;

const StyledOverlay = styled.div`
  display: ${ props => props.open ? 'block' : 'none' };
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.75);
`;

const Header = forwardRef(({ children, canFloat, searchOpen, onOverlayClick }, ref) => {
  const { data: user } = useUser();
  const theme = useTheme();
  return (
    <StyledHeader className="main" ref={ ref } theme={ theme } canFloat={ canFloat }>
      <StyledOverlay open={ searchOpen } onClick={ onOverlayClick } />
      <ToastNotificationsComponent />
      {!user?.isImpersonated && <BalanceDueModal />}
      <AddToWishlistModal />
      <ExternalSupplierModal />
      <StockAlertModal />
      { children }
    </StyledHeader>
  );
});

Header.propTypes = {
  children: node,
  canFloat: bool,
  searchOpen: bool,
  onOverlayClick: func
};
Header.displayName = 'HeaderComponent';

export default Header;
